import React from "react";
import { Card, CardBody, Spinner } from "reactstrap";
import { ConnectComponentsProvider, ConnectAccountOnboarding } from "@stripe/react-connect-js";
import { useStripeConnect } from "./StripeConnectContext";

/**
 * Stripe Connect embedded Account Onboarding — collects/verifies KYC +
 * payout bank account info directly inside Porcher (no redirect). Rendered
 * only while onboarding/verification is incomplete; once Stripe reports
 * `onboardingComplete`, the Payments page swaps this out for the
 * balances/payouts/account-management widgets instead (see
 * StripeBalancePayouts.jsx, StripePayoutHistory.jsx, StripePayoutAccount.jsx).
 */
const RentPayoutsSetup = () => {
  const { status, statusLoading, connectInstance, started, refreshStatus } = useStripeConnect();

  if (statusLoading || status?.onboardingComplete || !started) return null;

  return (
    <Card className="mb-4">
      <CardBody>
        <h5 className="mb-1">Complete your payout setup</h5>
        <p className="text-muted mb-3">
          Stripe securely verifies your identity and payout information before rent collected
          through Porcher can be deposited to you.
        </p>

        {connectInstance ? (
          <ConnectComponentsProvider connectInstance={connectInstance}>
            <ConnectAccountOnboarding onExit={refreshStatus} />
          </ConnectComponentsProvider>
        ) : (
          <div className="text-center py-4"><Spinner color="primary" /></div>
        )}
      </CardBody>
    </Card>
  );
};

export default RentPayoutsSetup;
